export type AuthorityRole =
  | 'SUPERINTENDENT'
  | 'VICE_SUPERINTENDENT'
  | 'PRESBYTER'
  | 'VICE_PRESBYTER'
  | 'PRESIDENT'
  | 'VICE_PRESIDENT'
  | 'SECRETARY'
  | 'TREASURER'
  | 'VOCAL_1'
  | 'VOCAL_2';

export type OrgType = 'DISTRICT' | 'REGION' | 'NATIONAL';

export const ROLE_LABELS: Record<AuthorityRole, string> = {
  SUPERINTENDENT:      'Superintendente',
  VICE_SUPERINTENDENT: 'Vice Superintendente',
  PRESBYTER:           'Presbítero',
  VICE_PRESBYTER:      'Vice Presbítero',
  PRESIDENT:           'Presidente',
  VICE_PRESIDENT:      'Vicepresidente',
  SECRETARY:           'Secretario',
  TREASURER:           'Tesorero',
  VOCAL_1:             'Vocal 1',
  VOCAL_2:             'Vocal 2',
};

export const DISTRICT_ROLES: AuthorityRole[] = [
  'SUPERINTENDENT', 'VICE_SUPERINTENDENT', 'SECRETARY', 'TREASURER', 'VOCAL_1', 'VOCAL_2',
];

export const REGION_ROLES: AuthorityRole[] = [
  'PRESBYTER', 'VICE_PRESBYTER', 'SECRETARY', 'TREASURER', 'VOCAL_1', 'VOCAL_2',
];

export const NATIONAL_ROLES: AuthorityRole[] = [
  'PRESIDENT', 'VICE_PRESIDENT', 'SECRETARY', 'TREASURER',
];

export interface AuthorityPosition {
  id: string;
  org_type: OrgType;  // 'DISTRICT' | 'REGION' | 'NATIONAL'
  district_id: string | null;
  region_id: string | null;
  minister_id: string;
  role: AuthorityRole;
  started_at: string;   // ISO date
  ended_at: string | null;
  notes: string | null;
  created_at: string;
  created_by: string | null;
  updated_at: string | null;
  updated_by: string | null;
  // Joined
  minister?: {
    id: string;
    adb_code: string;
    full_name: string | null;
    profile_picture_filename: string | null;
  };
}
